import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconCursorDoubleClick = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d="M23.998,20.809 C24.000,21.078 23.895,21.336 23.705,21.526 L21.522,23.708 C21.335,23.895 21.080,24.000 20.815,24.000 C20.813,24.000 20.809,24.000 20.806,24.000 C20.538,23.997 20.282,23.887 20.095,23.694 L15.985,19.427 L13.706,21.707 C13.461,21.952 13.107,22.053 12.769,21.973 C12.432,21.894 12.160,21.645 12.050,21.316 L8.051,9.316 C7.931,8.957 8.024,8.561 8.292,8.293 C8.560,8.025 8.956,7.932 9.315,8.052 L10.989,8.609 C10.991,8.573 10.999,8.537 10.999,8.500 C10.999,7.122 9.877,6.000 8.499,6.000 C7.121,6.000 5.999,7.122 5.999,8.500 C5.999,9.354 6.428,10.141 7.147,10.604 C7.611,10.903 7.745,11.522 7.446,11.986 C7.255,12.283 6.933,12.444 6.605,12.444 C6.419,12.444 6.232,12.393 6.064,12.285 C4.772,11.452 4.000,10.037 4.000,8.500 C4.000,6.019 6.018,4.000 8.499,4.000 C10.980,4.000 12.999,6.019 12.999,8.500 C12.999,8.756 12.973,9.008 12.931,9.257 L14.832,9.891 C14.932,9.435 14.999,8.973 14.999,8.500 C14.999,4.916 12.083,2.000 8.499,2.000 C4.915,2.000 2.000,4.916 2.000,8.500 C2.000,11.857 4.616,14.703 7.956,14.978 C8.507,15.023 8.916,15.506 8.871,16.057 C8.828,16.579 8.390,16.975 7.875,16.975 C7.848,16.975 7.820,16.973 7.792,16.971 C3.423,16.611 -0.000,12.890 -0.000,8.500 C-0.000,3.813 3.812,0.000 8.499,0.000 C13.186,0.000 16.998,3.813 16.998,8.500 C16.998,9.189 16.887,9.861 16.725,10.522 L21.314,12.051 C21.643,12.161 21.891,12.433 21.971,12.770 C22.051,13.108 21.950,13.462 21.705,13.707 L19.425,15.987 L23.691,20.098 C23.885,20.284 23.995,20.541 23.998,20.809 ZM17.305,16.720 C17.111,16.534 17.001,16.278 16.998,16.009 C16.996,15.740 17.101,15.483 17.291,15.293 L19.147,13.437 L10.580,10.581 L13.436,19.149 L15.291,17.293 C15.479,17.105 15.733,17.000 15.998,17.000 C16.001,17.000 16.005,17.000 16.008,17.000 C16.276,17.002 16.532,17.113 16.719,17.306 L20.829,21.573 L21.570,20.831 L17.305,16.720 Z"
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconCursorDoubleClick.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
